import Vue from 'vue'
import VueRouter from 'vue-router'
import { recordVisit } from '@/api/visit'

Vue.use(VueRouter)

const pageNameMap = {
  'home': '首页',
  'about': '关于我们',
  'login': '登录页',
  'register': '注册页',
  'passwordRecovery': '密码找回',
  'personalHomeView': '个人主页',
  'otherUserHomeView': '用户主页',
  'followingListView': '关注列表',
  'fansListView': '粉丝列表',
  'helpFeedbackView': '帮助反馈',
  'searchResult': '搜索结果',
  'homeMusic': '音乐播放器',
  'ArticlePublish': '发布文章',
  'VideoPublish': '发布视频',
  'ShuoshuoPublish': '发布说说',
  'ShuoshuoDetail': '说说详情',
  'AlbumEdit': '编辑相册',
  'HomeAlbum': '相册页面',
  'AlbumDetail': '相册详情',
  'VideoDetail': '视频详情',
  'ArticleDetail': '文章详情',
  'message': '站内消息',
  'friendList': '好友列表',
  'chat': '聊天页面',
  'announcementDetail': '公告详情',
  'messageBoard': '留言板'
}

function detectDeviceType() {
  const ua = navigator.userAgent
  if (/Mobile|Android|iPhone|iPad|iPod/i.test(ua)) {
    if (/iPad|Tablet/i.test(ua)) return 3
    return 2
  }
  return 1
}

function sendVisitRecord(to) {
  try {
    const userId = localStorage.getItem('userId')
    const pageName = pageNameMap[to.name] || to.name || '未命名页面'
    const data = {
      userId: userId ? parseInt(userId) : null,
      visitUrl: window.location.href,
      pageName: pageName,
      userAgent: navigator.userAgent,
      deviceType: detectDeviceType(),
      referer: document.referrer || ''
    }
    recordVisit(data).catch(() => {})
  } catch (e) {
    // 静默失败，不影响用户体验
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/HomeView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/system/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue')
  },
  {
    path: '/passwordRecovery',
    name: 'passwordRecovery',
    component: () => import('@/views/auth/PasswordRecoveryView.vue')
  },
  {
    path: '/backgroundSettingPage',
    redirect: '/'
  },
  {
    path: '/personalHomeView',
    name: 'personalHomeView',
    component: () => import('@/views/user/PersonalHomeView.vue')
  },
  {
    path: '/user/home/:userId',
    name: 'otherUserHomeView',
    component: () => import('@/views/user/OtherUserHomeView.vue')
  },
  {
    path: '/user/following/:userId',
    name: 'followingListView',
    component: () => import('@/views/user/FollowingListView.vue')
  },
  {
    path: '/user/fans/:userId',
    name: 'fansListView',
    component: () => import('@/views/user/FansListView.vue')
  },
  {
    path: '/helpFeedbackView',
    name: 'helpFeedbackView',
    component: () => import('@/views/system/HelpFeedbackView.vue')
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import('@/components/common/LoadingPage.vue')
  },
  {
    path: '/searchResult',
    name: 'searchResult',
    component: () => import('@/views/search/SearchResult.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/homeMusic',
    name: 'homeMusic',
    component: () => import('@/components/kyu-player/KyuMusicPlayer.vue')
  },
  {
    path: '/article/publish',
    name: 'ArticlePublish',
    component: () => import('@/views/publish/ArticlePublishView.vue')
  },
  {
    path: '/video/publish',
    name: 'VideoPublish',
    component: () => import('@/views/publish/VideoPublishView.vue')
  },
  {
    path: '/shuoshuo/publish',
    name: 'ShuoshuoPublish',
    component: () => import('@/views/publish/ShuoshuoPublishView.vue')
  },
  {
    path: '/shuoshuo/:id',
    name: 'ShuoshuoDetail',
    component: () => import('@/views/detail/ShuoshuoDetailView.vue')
  },
  {
    path: '/album/edit',
    name: 'AlbumEdit',
    component: () => import('@/views/home/EditAlbumView.vue')
  },
  {
    path: '/home-album',
    name: 'HomeAlbum',
    component: () => import('@/views/home/HomeAlbum.vue')
  },
  {
    path: '/album/:id',
    name: 'AlbumDetail',
    component: () => import('@/views/home/HomeAlbum.vue')
  },
  {
    path: '/video/:id',
    name: 'VideoDetail',
    component: () => import('@/views/detail/VideoDetailView.vue')
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/detail/ArticleDetail.vue'),
    meta: { title: '图文详情' }
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/message/MessageView.vue'),
    meta: { title: '站内消息', keepAlive: true }
  },
  {
    path: '/friendList',
    name: 'friendList',
    component: () => import('@/views/message/FriendListView.vue'),
    meta: { title: '好友列表', keepAlive: true }
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/message/ChatView.vue'),
    meta: { title: '聊天' }
  },
  {
    path: '/announcement/:id',
    name: 'announcementDetail',
    component: () => import('@/views/system/AnnouncementDetail.vue'),
    meta: { title: '公告详情' }
  },
  {
    path: '/messageBoard',
    name: 'messageBoard',
    component: () => import('@/views/system/MessageBoard.vue'),
    meta: { title: '留言板' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/loading') {
    sendVisitRecord(to)
  }
  next()
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 导航重复/被取消时静默处理(多请求并发401会触发)
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationCancelled') {
      return
    }
    return Promise.reject(err)
  })
}

const originalReplace = router.replace
router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationCancelled') {
      return
    }
    return Promise.reject(err)
  })
}

export default router
